<template>
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
  >
    <path d="M4.5 8H9.5C9.77614 8 10 8.22386 10 8.5C10 8.74546 9.82312 8.94961 9.58988 8.99194L9.5 9H4.5C4.22386 9 4 8.77614 4 8.5C4 8.25454 4.17688 8.05039 4.41012 8.00806L4.5 8H9.5H4.5ZM2.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.74546 11.8231 4.94961 11.5899 4.99194L11.5 5H2.5C2.22386 5 2 4.77614 2 4.5C2 4.25454 2.17688 4.05039 2.41012 4.00806L2.5 4H11.5H2.5ZM0.5 0H13.5C13.7761 0 14 0.223858 14 0.5C14 0.74546 13.8231 0.949608 13.5899 0.991944L13.5 1H0.5C0.223858 1 0 0.776142 0 0.5C0 0.25454 0.176875 0.0503916 0.410124 0.00805569L0.5 0H13.5H0.5Z" />
  </svg>
</template>
